import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getCartItemCount } from "../../utils/cart";
import AuthModal from "./AuthModal";
import {
  BaseUrl,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
} from "../../Services/Urls";
import { makeApiRequest, callApi } from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import { decryptOtp } from "../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../Context/Context";

const Navbar = () => {
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error("useApiContext must be used within a ApiContextProvider");
  }

  const { logindata, setlogindata, userData, setuserData } = context;
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [showAuthModal, setShowAuthModal] = useState(false);
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
  const [isNewsDropdownOpen, setIsNewsDropdownOpen] = useState(false);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [isMobileUserMenuOpen, setIsMobileUserMenuOpen] = useState(false);
  const userDropdownRef = useRef<HTMLDivElement>(null);
  const mobileUserDropdownRef = useRef<HTMLDivElement>(null);
  const [cartCount, setCartCount] = useState(0);
  const location = useLocation();

  // Close menus when route changes
  // useEffect(() => {
  //   setIsMobileMenuOpen(false);
  //   setIsAboutDropdownOpen(false);
  //   setIsNewsDropdownOpen(false);
  //   setIsUserDropdownOpen(false);
  //   setIsMobileUserMenuOpen(false);
  // }, [location]);

  // Close user dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        userDropdownRef.current &&
        !userDropdownRef.current.contains(e.target as Node)
      ) {
        setIsUserDropdownOpen(false);
      }
      if (
        mobileUserDropdownRef.current &&
        !mobileUserDropdownRef.current.contains(e.target as Node)
      ) {
        setIsMobileUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
  }, []);

  useEffect(() => {
    getCartCount(); // initial load

    const updateCart = () => {
      getCartCount();
    };

    window.addEventListener("cartUpdated", updateCart);

    return () => {
      window.removeEventListener("cartUpdated", updateCart);
    };
  }, []);

  const getCartCount = () => {
    const cart = localStorage.getItem("cart-UniversalDairy");

    if (cart) {
      const parsedCart = JSON.parse(cart);
      setCartCount(parsedCart.length);
    } else {
      setCartCount(0);
    }
  };
  const isHomePage = location.pathname === "/";
  const isActive = (path: string) => location.pathname === path;

  const handleDownloadBrochure = () => {
    try {
      const link = document.createElement("a");
      link.href =
        "https://radheybiotech.com/assets/brochure/Radhey-Biotech-Brochure.pdf";
      link.download = "Radhey-Biotech-Brochure.pdf";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download brochure:", error);
    }
  };
  const [isScrolled, setIsScrolled] = useState(false);

  const handleLogout = () => {
    setlogindata({});
    setuserData({});

    setLogindata();
    setUserdata();

    localStorage.removeItem("loginData-UniversalDairy");
    localStorage.removeItem("UserData-UniversalDairy");

    setIsLoggedIn(false);
    setIsUserDropdownOpen(false);
    navigate("/");
  };

      const handleLoginSuccess = () => {
    setShowAuthModal(false);
    setIsLoggedIn(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
     <AuthModal 
            isOpen={showAuthModal} 
            onClose={() => setShowAuthModal(false)}
            onLoginSuccess={handleLoginSuccess}
          />

      <header className="fixed top-0 left-0 right-0 z-50">
        {/* Top Green Bar */}
        {/* Top Green Bar */}
        <div className="bg-[#1A2B4A]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-10">
              {/* Left - Contact Info */}
              <div className="hidden sm:flex items-center space-x-6">
                <a
                  href="mailto:info@dialerp.com"
                  className="flex items-center text-white text-xs transition-colors"
                >
                  <i className="ri-mail-line mr-2 text-sm"></i>
                  info@dialerp.com
                </a>
                <a
                  href="tel:+919560444000"
                  className="flex items-center text-xs text-white transition-colors"
                >
                  <i className="ri-phone-line mr-2 text-sm"></i>
                  +91 9560444000
                </a>
              </div>

              {/* Right - Social Links */}
              <div className="flex items-center space-x-4 ml-auto">
                <a
                  href="https://www.linkedin.com/company/dialerp/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-6 h-6 flex items-center justify-center text-white transition-colors"
                >
                  <i className="ri-linkedin-fill text-sm"></i>
                </a>
                <a
                  href="https://www.instagram.com/dial.erp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-6 h-6 flex items-center justify-center text-white transition-colors"
                >
                  <i className="ri-instagram-line text-sm"></i>
                </a>

                <a
                  href="https://wa.me/919560444000"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-6 h-6 flex items-center justify-center text-white transition-colors"
                >
                  <i className="ri-whatsapp-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Main White Navigation Bar */}
        <div className="bg-white shadow-md">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <Link to="/" className="flex items-center gap-3">
                <img
                  src="../images/universal-dairy.svg"
                  alt="Universal DPU Logo"
                  className="h-12 w-auto"
                />
                <div className="flex flex-col">
                  <span
                    className={`text-lg font-bold leading-tight ${isScrolled ? "text-[#1A2B4A]" : "text-[#1A2B4A]"}`}
                  >
                    Universal Dairy Tech
                  </span>
                </div>
              </Link>

              {/* Desktop navigation */}

              {/* User Menu - Desktop (always visible in header bar) */}
              <div
                className="hidden lg:flex items-center ml-4"
                ref={userDropdownRef}
              >
                <nav className="hidden lg:flex items-center space-x-8">
                  <Link
                    to="/"
                    className={`text-sm font-medium transition-colors whitespace-nowrap ${
                      isActive("/")
                        ? "text-primary"
                        : "text-gray-700 hover:text-primary"
                    }`}
                  >
                    Home
                  </Link>

                  <Link
                    to="/software"
                    className={`text-sm font-medium transition-colors whitespace-nowrap ${
                      isActive("/software")
                        ? "text-primary"
                        : "text-gray-700 hover:text-primary"
                    }`}
                  >
                    Software
                  </Link>

                  <Link
                    to="/products"
                    className={`text-sm font-medium transition-colors whitespace-nowrap ${
                      isActive("/products")
                        ? "text-primary"
                        : "text-gray-700 hover:text-primary"
                    }`}
                  >
                    Products
                  </Link>

                  <Link
                    to="/about"
                    className={`text-sm font-medium transition-colors whitespace-nowrap ${
                      isActive("/about")
                        ? "text-primary"
                        : "text-gray-700 hover:text-primary"
                    }`}
                  >
                    About
                  </Link>

                  <Link
                    to="/news-research"
                    className={`text-sm font-medium transition-colors whitespace-nowrap ${
                      isActive("/news-research")
                        ? "text-primary"
                        : "text-gray-700 hover:text-primary"
                    }`}
                  >
                    Media
                  </Link>

                  <Link
                    to="/contact"
                    className={`text-sm font-medium transition-colors whitespace-nowrap ${
                      isActive("/contact")
                        ? "text-primary"
                        : "text-gray-700 hover:text-primary"
                    }`}
                  >
                    Contact
                  </Link>

                  <Link
                    to="/cart"
                    className={`relative p-2 cursor-pointer ${
                      isScrolled || !isHomePage
                        ? "text-gray-800 hover:text-amber-600"
                        : "text-gray hover:text-amber-200"
                    }`}
                  >
                    <i className="ri-shopping-cart-line text-2xl"></i>
                    {cartCount > 0 && (
                      <span className="absolute -top-1 -right-1 bg-amber-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                        {cartCount}
                      </span>
                    )}
                  </Link>
                </nav>

                {logindata && Object.keys(logindata).length > 0 ? (
                  <button
                    onClick={() => setIsUserDropdownOpen(!isUserDropdownOpen)}
                    className={`w-9 h-9 flex items-center justify-center rounded-full border-2 transition-all cursor-pointer ${
                      isActive("/news-research/add-content") ||
                      isActive("/my-leads")
                        ? "border-primary bg-primary text-gray-700"
                        : "border-gray-300 bg-white text-gray-600 hover:border-primary hover:text-primary"
                    }`}
                    style={{ marginLeft: 10 }}
                  >
                    <i className="ri-user-line text-base"></i>
                  </button>
                ) : (
                  <button
                    onClick={() => setShowAuthModal(true)}
                    className="flex items-center gap-2 px-4 h-9 rounded-md bg-[#0a7f82] text-white hover:bg-[#0a7f82]/90 transition-all"
                    style={{ marginLeft: 10 }}
                  >
                    
                    <span className="text-sm font-medium">Login</span>
                  </button>
                )}

                <div
                  className={`absolute top-full right-4 mt-2 w-52 bg-white shadow-xl rounded-lg overflow-hidden transition-all duration-200 border border-gray-100 ${
                    isUserDropdownOpen
                      ? "opacity-100 visible translate-y-0"
                      : "opacity-0 invisible -translate-y-1"
                  }`}
                >
                  <div className="px-4 py-3 border-b border-gray-100">
                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">
                      {userData?.LedgerName || ""}
                    </p>
                  </div>

                  <Link
                    to="/profile"
                    className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors"
                  >
                    <i className="ri-user-line mr-3 text-base"></i>
                    My Profile
                  </Link>

                  <Link
                    to="/address"
                    className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors"
                  >
                    <i className="ri-map-pin-line mr-3 text-base"></i>
                    My Address
                  </Link>

                  <Link
                    to="/orders"
                    className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors"
                  >
                    <i className="ri-shopping-bag-line  mr-3 text-base"></i>
                    My Orders
                  </Link>

                  {logindata &&
                    Object.keys(logindata).length > 0 &&
                    (logindata?.partySr == 1003 ||
                      logindata?.partySr == 1002) && (
                      <>
                        <Link
                          to="/news-research/add-content"
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors"
                        >
                          <i className="ri-add-circle-line mr-3 text-base"></i>
                          Content
                        </Link>

                         <Link
                          to="/category"
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors"
                        >
                          <i className="ri-add-circle-line mr-3 text-base"></i>
                          Category
                        </Link>


                        <Link
                          to="/my-leads"
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors"
                        >
                          <i className="ri-contacts-book-line mr-3 text-base"></i>
                          Enquiries
                        </Link>
                      </>
                    )}

                  <div
                    onClick={() => {
                      handleLogout();
                    }}
                    className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors"
                  >
                    <i
                      style={{ color: "red" }}
                      className="ri-logout-box-line mr-3 text-base"
                    ></i>
                    Logout
                  </div>
                </div>
              </div>

              {/* Mobile: User icon + Hamburger */}
              <div className="lg:hidden flex items-center space-x-3">
                <Link
                  to="/cart"
                  className={`relative p-2 cursor-pointer ${
                    isScrolled || !isHomePage
                      ? "text-gray-800 hover:text-amber-600"
                      : "text-gray hover:text-amber-200"
                  }`}
                >
                  <i className="ri-shopping-cart-line text-2xl"></i>
                  {cartCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-amber-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                      {cartCount}
                    </span>
                  )}
                </Link>
                {/* User Menu - Mobile (always visible in header bar) */}
                <div className="relative" ref={mobileUserDropdownRef}>
                  {logindata && Object.keys(logindata).length > 0 ? (
                    <button
                      onClick={() =>
                        setIsMobileUserMenuOpen(!isMobileUserMenuOpen)
                      }
                      className={`w-8 h-8 flex items-center justify-center rounded-full border-2 transition-all cursor-pointer ${
                        isActive("/news-research/add-content") ||
                        isActive("/my-leads")
                          ? "border-primary bg-primary text-white"
                          : "border-gray-300 bg-white text-gray-600 hover:border-primary hover:text-primary"
                      }`}
                    >
                      <i className="ri-user-line text-sm"></i>
                    </button>
                  ) : (
                      <button
                    onClick={() => setShowAuthModal(true)}
                    className="flex items-center gap-2 px-4 h-9 rounded-md bg-[#0a7f82] text-white hover:bg-[#0a7f82]/90 transition-all"
                    style={{ marginLeft: 10 }}
                  >
                    
                    <span className="text-sm font-medium">Login</span>
                  </button>
                  
                  )}

                  <div
                    className={`absolute top-full right-0 mt-2 w-48 bg-white shadow-xl rounded-lg overflow-hidden transition-all duration-200 border border-gray-100 z-50 ${
                      isMobileUserMenuOpen
                        ? "opacity-100 visible translate-y-0"
                        : "opacity-0 invisible -translate-y-1"
                    }`}
                  >
                    <div className="px-4 py-2.5 border-b border-gray-100">
                      <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">
                        {userData?.LedgerName || ""}
                      </p>
                    </div>

                    <Link
                      to="/profile"
                      className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors"
                    >
                      <i className="ri-user-line mr-3 text-base"></i>
                      My Profile
                    </Link>

                    <Link
                      to="/address"
                      className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors"
                    >
                      <i className="ri-map-pin-line mr-3 text-base"></i>
                      My Address
                    </Link>

                    <Link
                      to="/orders"
                      className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors"
                    >
                      <i className="ri-shopping-bag-line  mr-3 text-base"></i>
                      My Orders
                    </Link>

                    {logindata &&
                      Object.keys(logindata).length > 0 &&
                      (logindata?.partySr == 1003 ||
                        logindata?.partySr == 1002) && (
                        <>
                          <Link
                            to="/news-research/add-content"
                            className={`flex items-center px-4 py-2.5 text-sm transition-colors ${
                              isActive("/news-research/add-content")
                                ? "text-primary font-medium bg-primary/5"
                                : "text-gray-700 hover:bg-primary/10 hover:text-primary"
                            }`}
                          >
                            <i className="ri-add-circle-line mr-3 text-base"></i>
                            Content
                          </Link>

                                  <Link
                            to="/category"
                            className={`flex items-center px-4 py-2.5 text-sm transition-colors ${
                              isActive("/news-research/add-content")
                                ? "text-primary font-medium bg-primary/5"
                                : "text-gray-700 hover:bg-primary/10 hover:text-primary"
                            }`}
                          >
                            <i className="ri-add-circle-line mr-3 text-base"></i>
                            Category
                          </Link>


                          <Link
                            to="/my-leads"
                            className={`flex items-center px-4 py-2.5 text-sm transition-colors ${
                              isActive("/my-leads")
                                ? "text-primary font-medium bg-primary/5"
                                : "text-gray-700 hover:bg-primary/10 hover:text-primary"
                            }`}
                          >
                            <i className="ri-contacts-book-line mr-3 text-base"></i>
                            Enquiries
                          </Link>
                        </>
                      )}

                    <div
                      onClick={() => {
                        handleLogout();
                      }}
                      className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors"
                    >
                      <i
                        style={{ color: "red" }}
                        className="ri-logout-box-line mr-3 text-base"
                      ></i>
                      Logout
                    </div>
                  </div>
                </div>

                {/* Mobile menu toggle */}
                <button
                  className="text-gray-700 hover:text-primary transition-colors"
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                  aria-label="Toggle menu"
                >
                  <i
                    className={`text-2xl ${isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}
                  ></i>
                </button>
              </div>
            </div>
          </div>

          {/* Mobile navigation */}
          {isMobileMenuOpen && (
            <div className="lg:hidden bg-white border-t border-gray-200">
              <div className="px-4 py-4 space-y-3">
                <Link
                  to="/"
                  className={`block py-2 text-sm font-medium ${
                    isActive("/") ? "text-primary" : "text-gray-700"
                  }`}
                >
                  Home
                </Link>

                <Link
                  to="/software"
                  className={`block py-2 text-sm font-medium ${
                    isActive("/software") ? "text-primary" : "text-gray-700"
                  }`}
                >
                  Software
                </Link>

                <Link
                  to="/products"
                  className={`block py-2 text-sm font-medium ${
                    isActive("/products") ? "text-primary" : "text-gray-700"
                  }`}
                >
                  Products
                </Link>

                <Link
                  to="/about"
                  className={`block py-2 text-sm font-medium ${
                    isActive("/about") ? "text-primary" : "text-gray-700"
                  }`}
                >
                  About
                </Link>

                <Link
                  to="/news-research"
                  className={`block py-2 text-sm font-medium ${
                    isActive("/news-research")
                      ? "text-primary"
                      : "text-gray-700"
                  }`}
                >
                  Media
                </Link>

                <Link
                  to="/contact"
                  className={`block py-2 text-sm font-medium ${
                    isActive("/contact") ? "text-primary" : "text-gray-700"
                  }`}
                >
                  Contact
                </Link>

                {/* <Link
                  to="/cart"
                  className={`block py-2 text-sm font-medium ${
                    isActive("/cart") ? "text-primary" : "text-gray-700"
                  }`}
                >
                  {cartCount > 0 ? `Cart ${`(${cartCount})`}` : "Cart"}
                </Link> */}
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Spacer to prevent content from hiding behind fixed header */}
      <div className="h-[104px]"></div>
    </>
  );
};

export default Navbar;
